import api from './api';

class StatsService {
  /**
   * Récupérer toutes les statistiques globales
   */
  async getGlobalStats() {
    const response = await api.get('/api/admin/stats');
    return response.data;
  }
}

export default new StatsService();

